// B1 - Ünite 4: First Conditional
// Hedef: If + present, will + fiil (gerçek olasılıklar)

export const B1_UNIT_4 = {
  'B1-U4-L1': {
    id: 'B1-U4-L1',
    title: 'If + Present Simple, will + fiil',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 First Conditional',
          explanation: 'First Conditional gelecekte gerçekleşmesi muhtemel durumlar için kullanılır. If + Present Simple, will + fiil',
          table: {
            headers: ['If Clause', 'Main Clause', 'Türkçesi'],
            rows: [
              ['If it rains,', 'we will delay the flight.', 'Yağmur yağarsa, uçuşu erteleriz.'],
              ['If you study hard,', 'you will pass the exam.', 'Çok çalışırsan, sınavı geçersin.'],
              ['If passengers cooperate,', 'we will have a smooth flight.', 'Yolcular işbirliği yaparsa, rahat bir uçuş olur.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['If the weather improves, we will take off.', 'Hava düzelse, kalkacağız.'],
              ['If you need anything, I will help you.', 'Bir şeye ihtiyacınız olursa, yardım ederim.'],
              ['If there is turbulence, we will suspend service.', 'Türbülans olursa, servisi durdururuz.'],
              ['If the seatbelt sign is on, please remain seated.', 'Kemer işareti yanıyorsa, lütfen oturun.']
            ]
          }
        },
        {
          type: 'tip',
          content: '⚠️ If clause içinde WILL kullanmayın! If it will rain ❌ | If it rains ✓'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'If you _____ hard, you will pass the exam.',
          options: ['study', 'will study', 'studied', 'studies'],
          correct: 'study',
          explanation: 'If clause: Present Simple'
        },
        {
          type: 'multipleChoice',
          question: 'If the weather is bad, we _____ delay the flight.',
          options: ['will', 'would', 'are', 'do'],
          correct: 'will',
          explanation: 'Main clause: will + fiil'
        },
        {
          type: 'fillInBlank',
          sentence: 'If you _____ (need) help, I will assist you.',
          answer: 'need',
          hint: 'If clause: Present Simple'
        },
        {
          type: 'fillInBlank',
          sentence: 'If there is turbulence, we _____ (suspend) the service.',
          answer: 'will suspend',
          hint: 'Main clause: will + fiil'
        }
      ]
    }
  },
  'B1-U4-L2': {
    id: 'B1-U4-L2',
    title: 'Unless = If not',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Unless',
          explanation: 'Unless = If not. "Çnless" cümlesinde olumsuz kullanmayın!',
          table: {
            headers: ['Unless', 'If not', 'Türkçesi'],
            rows: [
              ['Unless you hurry, you\'ll miss the flight.', 'If you don\'t hurry...', 'Acele etmezsen, uçuşu kaçırırsın.'],
              ['Unless it rains, we\'ll fly on time.', 'If it doesn\'t rain...', 'Yağmur yağmazsa, zamanında uçarız.'],
              ['Unless there\'s an emergency, remain seated.', 'If there isn\'t an emergency...', 'Acil durum yoksa, oturun.']
            ]
          }
        },
        {
          type: 'tip',
          content: '⚠️ Unless = If not | YANLIŞ: Unless you don\'t hurry ❌ | DOĞRU: Unless you hurry ✓'
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Unless Örnekleri',
          table: {
            headers: ['Unless', 'Türkçesi'],
            rows: [
              ['Unless the weather improves, we can\'t take off.', 'Hava düzelmezse, kalkamayız.'],
              ['Unless you fasten your seatbelt, you can\'t stay here.', 'Kemerinizi bağlamazsanız, burada kalamazsınız.'],
              ['Unless there\'s turbulence, the service will continue.', 'Türbülans olmadıkça, servis devam edecek.']
            ]
          }
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ you hurry, you will miss the flight.',
          options: ['Unless', 'If', 'When', 'Although'],
          correct: 'Unless',
          explanation: 'Unless = If you don\'t'
        },
        {
          type: 'multipleChoice',
          question: 'Unless the weather _____, we can\'t take off.',
          options: ['improves', 'doesn\'t improve', 'will improve', 'improved'],
          correct: 'improves',
          explanation: 'Unless + Present Simple (olumlu!)'
        },
        {
          type: 'fillInBlank',
          sentence: 'Unless you _____ (study), you won\'t pass the exam.',
          answer: 'study',
          hint: 'Unless + Present Simple (olumsuz DEĞİL!)'
        }
      ]
    }
  },
  'B1-U4-L3': {
    id: 'B1-U4-L3',
    title: 'When, As soon as, Before, After',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Time Clauses',
          explanation: 'Time clause (when, as soon as, before, after) içinde WILL kullanmayın!',
          table: {
            headers: ['Time Clause', 'Main Clause', 'Türkçesi'],
            rows: [
              ['When we land,', 'I will call you.', 'İndiğimizde seni ararım.'],
              ['As soon as the sign is off,', 'you can move.', 'İşaret söner sönmez hareket edebilirsiniz.'],
              ['Before you leave,', 'check your belongings.', 'Ayrılmadan önce eşyalarınızı kontrol edin.'],
              ['After we take off,', 'we will serve drinks.', 'Kalktıktan sonra içecek servis edeceğiz.']
            ]
          }
        },
        {
          type: 'tip',
          content: '⚠️ Time clause + Present Simple | YANLIŞ: When we will land ❌ | DOĞRU: When we land ✓'
        },
        {
          type: 'vocabulary',
          title: '✈️ Havacılık Time Clauses',
          words: [
            { en: 'When we reach cruising altitude...', tr: 'Seyir irtifasına ulaştığımızda...', pronunciation: '' },
            { en: 'As soon as it\'s safe...', tr: 'Güvenli olur olmaz...', pronunciation: '' },
            { en: 'Before we land...', tr: 'İnmeden önce...', pronunciation: '' },
            { en: 'After we park at the gate...', tr: 'Kapıya park ettikten sonra...', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'When we _____, I will call you.',
          options: ['land', 'will land', 'landed', 'are landing'],
          correct: 'land',
          explanation: 'Time clause: Present Simple'
        },
        {
          type: 'multipleChoice',
          question: 'As soon as the seatbelt sign _____ off, you can move.',
          options: ['is', 'will be', 'was', 'being'],
          correct: 'is',
          explanation: 'Time clause: Present Simple'
        },
        {
          type: 'fillInBlank',
          sentence: 'Before you _____ (leave), please check your belongings.',
          answer: 'leave',
          hint: 'Time clause: Present Simple'
        }
      ]
    }
  },
  'B1-U4-L4': {
    id: 'B1-U4-L4',
    title: 'Real Possibilities',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Gerçek Olasılıklar',
          explanation: 'First Conditional gerçekleşmesi muhtemel durumlar içindir. "Eğer X olursa, Y olacak."',
          table: {
            headers: ['Durum', 'Sonuç', 'Örnek'],
            rows: [
              ['Hava kötüyse', 'Uçuş ertelenir', 'If the weather is bad, the flight will be delayed.'],
              ['Yardıma ihtiyacınız varsa', 'Yardım ederim', 'If you need help, I will assist you.'],
              ['Gecikirsen', 'Uçuşu kaçırırsın', 'If you\'re late, you will miss the flight.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '🎤 Mülakat Senaryoları',
          table: {
            headers: ['Soru', 'Cevap'],
            rows: [
              ['What will you do if a passenger is rude?', 'If a passenger is rude, I will remain calm and professional.'],
              ['What will you do if there is an emergency?', 'If there is an emergency, I will follow the safety procedures.'],
              ['What will happen if you get this job?', 'If I get this job, I will work hard every day.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta "What will you do if...?" soruları için First Conditional kullanın!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'If a passenger is rude, I _____ remain calm.',
          options: ['will', 'would', 'am', 'do'],
          correct: 'will',
          explanation: 'First Conditional: will + fiil'
        },
        {
          type: 'fillInBlank',
          sentence: 'If I _____ (get) this job, I will do my best.',
          answer: 'get',
          hint: 'If clause: Present Simple'
        },
        {
          type: 'fillInBlank',
          sentence: 'If there _____ (be) an emergency, I will follow procedures.',
          answer: 'is',
          hint: 'If clause: Present Simple'
        }
      ]
    }
  },
  'B1-U4-L5': {
    id: 'B1-U4-L5',
    title: 'Uygulama: Koşullu Bilgilendirme',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Koşullu Anonslar',
          table: {
            headers: ['Anons', 'Türkçesi'],
            rows: [
              ['If you need assistance, please press the call button.', 'Yardıma ihtiyacınız olursa, çağrı düğmesine basın.'],
              ['If there is turbulence, please fasten your seatbelt.', 'Türbülans olursa, lütfen kemerinizi bağlayın.'],
              ['Unless there is an emergency, please remain seated.', 'Acil durum olmadıkça, lütfen oturun.'],
              ['When we land, please wait for the seatbelt sign to turn off.', 'İndiğimizde, kemer işaretinin sönmesini bekleyin.']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '🎤 Mülakat Cevapları',
          words: [
            { en: 'If I face a problem, I will stay calm.', tr: 'Bir sorunla karşılaşırsam, sakin kalacağım.', pronunciation: '' },
            { en: 'If a passenger needs help, I will assist immediately.', tr: 'Bir yolcu yardıma ihtiyaç duyarsa, hemen yardım edeceğim.', pronunciation: '' },
            { en: 'Unless it\'s an emergency, I will follow procedures.', tr: 'Acil durum değilse, prosedürleri takip edeceğim.', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'speaking',
          instruction: 'Bu cümleleri okuyun:',
          phrases: [
            'If you need anything, please let me know.',
            'Unless there is an emergency, please remain seated.',
            'When we reach cruising altitude, we will begin service.',
            'If the weather is bad, the flight may be delayed.'
          ]
        },
        {
          type: 'fillInBlank',
          sentence: 'If passengers cooperate, we _____ (have) a smooth flight.',
          answer: 'will have',
          hint: 'Main clause: will + fiil'
        },
        {
          type: 'multipleChoice',
          question: 'When we _____ at the gate, you can disembark.',
          options: ['arrive', 'will arrive', 'arrived', 'arriving'],
          correct: 'arrive',
          explanation: 'Time clause: Present Simple'
        }
      ]
    }
  },
  'B1-U4-EXAM': {
    id: 'B1-U4-EXAM',
    title: 'Ünite 4 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'If the weather _____ bad, we will delay.',
        options: ['is', 'will be', 'was', 'would be'],
        correct: 'is',
        explanation: 'If clause: Present Simple'
      },
      {
        type: 'multipleChoice',
        question: 'If you study hard, you _____ pass.',
        options: ['will', 'would', 'are', 'do'],
        correct: 'will',
        explanation: 'Main clause: will + fiil'
      },
      {
        type: 'multipleChoice',
        question: '_____ you hurry, you will miss the flight.',
        options: ['Unless', 'If', 'When', 'Although'],
        correct: 'Unless',
        explanation: 'Unless = If not'
      },
      {
        type: 'multipleChoice',
        question: 'When we _____, I will call you.',
        options: ['land', 'will land', 'landed', 'landing'],
        correct: 'land',
        explanation: 'Time clause: Present Simple'
      },
      {
        type: 'fillInBlank',
        sentence: 'If a passenger _____ (need) help, I will assist.',
        answer: 'needs',
        hint: 'If clause: Present Simple (he/she = needs)'
      },
      {
        type: 'fillInBlank',
        sentence: 'Unless the weather _____ (improve), we can\'t fly.',
        answer: 'improves',
        hint: 'Unless + Present Simple (olumlu)'
      },
      {
        type: 'matchPairs',
        instruction: 'Eşleştirin',
        pairs: [
          { left: 'If + Present', right: 'will + fiil' },
          { left: 'Unless', right: 'If not' },
          { left: 'When/As soon as', right: 'Present Simple' }
        ]
      }
    ]
  }
};

export default B1_UNIT_4;
